import React from "react";
import Login from "../../Login";
import BaseModal, { MODALSIZES } from "../BaseModal";
import ModalEnum from "../BaseModal/ModalEnum";
import useLanguage from "../../../utilities/useLanguage";
import { getTranslation } from '../translations'

export default () => {
    const { lang } = useLanguage();

    return (
        <BaseModal backdropClassName={"modal-backdrop-glass"} modalId={ModalEnum.Login} modalSize={MODALSIZES.LOGIN}>
            <h5 className="mb-4 text-dark text-left">{getTranslation(lang).login}</h5>
            <Login className="login-modal" isModal={true}/>
        </BaseModal>
    );
};
